const LICENSE_ALLOCATION_RESOURCE_TYPE = {
  FULFILLABLE_ITEM: 'FULFILLABLE_ITEM',
  LICENSE: 'LICENSE',
};

export {LICENSE_ALLOCATION_RESOURCE_TYPE};
